<template>
  <b-card>
    <template v-slot:header>
      <b-row slot="header">
        <b-col>
            <span class="h4 font-weight-bold mb-0" v-if="title">{{title}}</span>
        </b-col>
        <b-col class="font-weight-bold mb-0 text-right">
          <slot name="icon" class="pl-2">
            <b-icon
                icon="question-circle"
                variant="orange"
                class="mr-1"
                v-b-tooltip.hover.top="tooltip"></b-icon>
          </slot>
          <slot name="icon" class="pl-2 ml-2">
            <b-icon
                :icon="icon1" variant="orange"
                @click="simInventoryToggle()"
                v-b-tooltip.hover.top="'Click here to enable or disable this item'"></b-icon>
          </slot>
        </b-col>
      </b-row>
    </template>
    <transition name="slide-fade">
      <div class="chart" v-if="toggleStatus">
        <div class="text-center w-100">
          <b-icon icon="three-dots"
                  class="text-center" animation="cylon"
                  font-scale="4"
                  v-if="loadingStatus"></b-icon>
        </div>
        <span v-if="!loadingStatus">
          <pie-chart
            id="pie-chart"
            :height="350"
            :chart-data="pieChart.chartData"
            :extra-options="pieChart.extraOptions"
          >
      </pie-chart>
        </span>
    </div>
    </transition>
  </b-card>
</template>

<script>

  import {Charts} from "../../../components/Charts/config";
  import PieChart from '../../../components/Charts/PieChart';
  import cardOpenStatusDirective from "../../../common/directive/card-open-status-directive";

  export default {
    name: "SimInventory",
    components: {
      PieChart
    },
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      icon: String,
      title: String,
      iconClasses: [String, Array],
      tooltip: String,
    },

    data() {
      return {
        toggleStatus: false,
        loadingStatus: true,
        icon1: 'arrow-right-square',
        downIcon: 'arrow-down-square',
        rightIcon: 'arrow-right-square',
        pieChart: {
          chartData: {
            labels: [],
            datasets: [{
              data: [],
              backgroundColor: [
                ['#f5365c'],
                ['#2dce89'],
                ['#5e72e4'],
                ['#fb6340'],
                ['#2aa2c0'],
                ['#fbb140']
              ],
              label: 'SIM Inventory'
            }],
          },
          options: {
            legend: {
              position: 'right',
              align: 'start',
              display: true,
            }
          },
          extraOptions: {
            responsive: true,
            legend: {
              display: true,
              position: 'right',
              align: 'start',
            },
            animation: {
              animateScale: true,
              animateRotate: true
            }
          }
        },
      }
    },
    mounted() {
      this.getCardStatus();

      this.$root.$on('simInventory', (event) => {
        this.loadingStatus = false;
        if (event) {
          let simInventoryData = [];
          let labels = [];
          for (let item of event) {
            simInventoryData.push(item['SIM_COUNT']);
            labels.push(item['SIM_STATUS'] + ' - ' + item['SIM_COUNT']);
          }
          this.pieChart.chartData.datasets[0] = {
            ...this.pieChart.chartData.datasets[0], data: simInventoryData
          };
          this.pieChart.chartData = {
            ...this.pieChart.chartData, labels: labels
          };
        }
      });
    },
    methods: {
      getCardStatus() {
        if (cardOpenStatusDirective.getOpenCardStatus()) {
          let cardStatus = cardOpenStatusDirective.getOpenCardStatus()['sim-inventory-collapse'];
          if (cardStatus) {
            this.icon1 = this.downIcon;
            this.toggleStatus = cardStatus;
          }
        }
      },

      simInventoryToggle() {
        let status = cardOpenStatusDirective.simInventoryStatus();
        if (status) {
          this.toggleStatus = !this.toggleStatus;
          if (this.toggleStatus) {
            this.icon1 = this.downIcon;
          } else {
            this.icon1 = this.rightIcon
          }
          this.$root.$emit('simInventoryOpen', this.btnActivated)
        }
      }
    }
  }
</script>

